import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { Block } from '@hvcgroep/design-system';

import { Button, WysiwygField } from '../../../../../components';

const BODY_TRANSLATION_VARIANT_FULL = 'full';
const BODY_TRANSLATION_VARIANT_TEL_ONLY = 'tel_only';
const BODY_TRANSLATION_VARIANT_EMAIL_ONLY = 'email_only';

const NodeVacancyFullBlockContact = (props) => {
  const {
    name,
    tel,
    email,
    whatsappLink,
    onVacancyApply,
  } = props;

  const { t } = useTranslation();

  const bodyTranslationVariant = useMemo(() => {
    if (tel && email) {
      return BODY_TRANSLATION_VARIANT_FULL;
    }

    if (tel) {
      return BODY_TRANSLATION_VARIANT_TEL_ONLY;
    }

    if (email) {
      return BODY_TRANSLATION_VARIANT_EMAIL_ONLY;
    }

    return '';
  }, [tel, email]);

  return (
    <Block padding="large">
      <h3>{t('vacancy_block_contact.title')}</h3>

      {bodyTranslationVariant && (
        <WysiwygField
          property="schema:text"
          html={t(`vacancy_block_contact.body.${bodyTranslationVariant}`, { name, tel, email })}
        />
      )}

      <div className="u-multiple-buttons u-multiple-buttons--vertical u-multiple-buttons--fit-content u-margin--top--5">
        <Button onClick={() => onVacancyApply()}>
          {t('apply_vacancy')}
        </Button>

        {whatsappLink && (
          <Button href={whatsappLink}>
            {t('vacancy_block_contact.whatsapp_link')}
          </Button>
        )}
      </div>
    </Block>
  );
};

export default NodeVacancyFullBlockContact;
